import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { WorkflowWithResolvedName } from '../../../shared/domain/workflows/types.no-deps'
import type { SupportedLanguage } from '../../../shared/i18n/types.no-deps'
import type { WorkflowParameter } from '../../../shared/domain/workflowParameter/types.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/workflows/:id' }

export interface OutputWorkflow extends WorkflowWithResolvedName {
    trainingRecommendations: number[]
    workflowParameters: WorkflowParameter[]
    tags?: string[]
}

type Params = { id: number }
type Body = never
type Query = {
    workflowVersion?: number
    includeDeleted?: boolean
    richText?: boolean
    tags?: string[]
    includeNonConcreteSteps?: boolean
    language?: SupportedLanguage
}
type Output = { workflow: OutputWorkflow }

export type GetEndpoint = Endpoint<Params, Body, Query, Output>

export const getRequest = (request: Request, args: RequestArgs<GetEndpoint>) => request<GetEndpoint>(route, args)
